import React from "react";
import { useNavButtons } from "../../common/NavButtonsProvider";
import TournamentsByDateFetcher from "./TournamentsByDateFetcher";
import { ErrorBoundary } from "../../common/ErrorBoundary";
import ErrorMessageWithLink from "../../common/ErrorMessageWithLink";
import ContentWrapper from "../../common/ContentWrapper";
import Tournament from "../Tournament";

function Wrapper(props) {
    const navButtons = useNavButtons();

    const btn = navButtons[0];

    if (btn == null) {
        return null;
    }

    const day = btn;
    const data = {date: day.date, sportId: day.sport.id, aggId: day.sport.aggregata};

    return props.renderItem(data);
}

export default function Today() {
    return (
        <Wrapper renderItem={(data) =>
            <TournamentsByDateFetcher {...data} renderItem={(tournamentsData) =>
                <ErrorBoundary fallback={<ErrorMessageWithLink />}>
                    {/* <ContentWrapper columns="1">
                    </ContentWrapper> */}
                    {tournamentsData.sport.map(s => {
                        return (
                            <React.Fragment key={s.id}>
                                <div className="c_42">
                                    <div className="c_42_1">
                                        <span className="c_42_1_1"></span>
                                        <span className="c_42_1_2">{s.descrizione}</span>
                                        {/* <Img className="c_42_1_3" src="icon_chevron.svg" height="16px" width="16px" data-rotate="270" /> */}
                                    </div>
                                    {/* <Img className="c_42_2" src="Favs_default.svg" height="16px" width="16px" /> */}
                                </div>
                                {/* <RenderOnScroll> */}
                                    <TournamentsByDateFetcher date={data.date} sportId={s.id} aggId={s.aggregata} renderItem={(data) =>
                                        <>
                                            {data.tournaments.map(t =>
                                                <Tournament key={t.id} data={t} />
                                            )}
                                        </>
                                    } />
                                {/* </RenderOnScroll> */}
                            </React.Fragment>
                        );
                    })}
                </ErrorBoundary>
            } />
        } />
    );
}
